module.exports = __webpack_public_path__ + "static/media/lisossomo.74213bbc.gif";